import React, { Component } from "react";
import { Route, NavLink, Link, Routes } from "react-router-dom";
import { withRouter, RenderRoute } from "../../../utils/router";
import { withRequest } from "../../../utils/request";
import { getLink } from "../../../utils/helpers";
import Loader from "../../general/Loader";
import PeriodosAcademicos from "./PeriodosAcademicos";
import Ciclos from "./Ciclos";
import Grados from "./Grados";
import Modalidades from "./Modalidades";
import Periodos from "./Periodos";
import Niveles from "./Niveles";
import Secciones from "./Secciones";
import Becas from "./Becas";
import SalidasOptativas from "./SalidasOptativas";
import PagosEducativos from "./PagosEducativos";
import Cocurriculares from "./Cocurriculares";

class Academica extends Component {
    state = {
        sucursal: {},
        loading: true,
        sucursales: [],
    };

    componentDidMount() {
        this.getSucursales();
    }

    getSucursales = async (url = null) => {
        const id = parseInt(this.props.match.params.id);
        url = url ? url : "sucursales";
        const sucursales = await this.props.request(url);

        if (sucursales.data) {
            this.setState({
                sucursal: sucursales.data.filter(s => s.id === id)[0],
                sucursales: sucursales.data,
                loading: false,
            });
        }
    };

    render() {
        const { loading } = this.state;

        if (loading) {
            return <Loader />;
        }

        return (
            <div>
                <div className='page-header'>
                    <Link to={getLink('/configuracion')}>&laquo; Volver a configuraciones</Link>
                    <h1 className='page-title'>
                        Configuración Académica
                    </h1>
                </div>
                <div className='row'>
                    <div className='col-md-2 page-sidebar'>
                        <ul className='list-unstyled page-sidebar__menu'>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/configuracion/academica`
                                    )}
                                    end
                                    className='nav-link'>
                                    Años Escolares
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/configuracion/academica/pagos-educativos`
                                    )}
                                    end
                                    className='nav-link'>
                                    Servicios Educativos
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/configuracion/academica/cocurriculares`
                                    )}
                                    end
                                    className='nav-link'>
                                    Cocurriculares
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/configuracion/academica/periodos`
                                    )}
                                    end
                                    className='nav-link'>
                                    Periodos
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/configuracion/academica/ciclos`
                                    )}
                                    end
                                    className='nav-link'>
                                    Ciclos
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/configuracion/academica/niveles`
                                    )}
                                    end
                                    className='nav-link'>
                                    Niveles
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/configuracion/academica/grados`
                                    )}
                                    end
                                    className='nav-link'>
                                    Grados
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/configuracion/academica/secciones`
                                    )}
                                    end
                                    className='nav-link'>
                                    Secciones
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/configuracion/academica/modalidades`
                                    )}
                                    end
                                    className='nav-link'>
                                    Modalidades
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/configuracion/academica/salidas-optativas`
                                    )}
                                    end
                                    className='nav-link'>
                                    Salidas Optativas
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/configuracion/academica/becas`
                                    )}
                                    end
                                    className='nav-link'>
                                    Becas
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className='col-md-10 p-l-40'>
                        <Routes>
                            <Route
                                path='/'
                                element={<RenderRoute render={(props) => (
                                    <PeriodosAcademicos {...props} />
                                )} />}
                            />
                            <Route
                                path='periodos'
                                element={<RenderRoute render={(props) => (
                                    <Periodos {...props} />
                                )} />}
                            />
                            <Route
                                path='ciclos'
                                element={<RenderRoute render={(props) => (
                                    <Ciclos {...props} />
                                )} />}
                            />
                            <Route
                                path='niveles'
                                element={<RenderRoute render={(props) => (
                                    <Niveles {...props} />
                                )} />}
                            />
                            <Route
                                path='grados'
                                element={<RenderRoute render={(props) => (
                                    <Grados {...props} />
                                )} />}
                            />
                            <Route
                                path='secciones'
                                element={<RenderRoute render={(props) => (
                                    <Secciones {...props} />
                                )} />}
                            />
                            <Route
                                path='modalidades'
                                element={<RenderRoute render={(props) => (
                                    <Modalidades {...props} />
                                )} />}
                            />
                            <Route
                                path='salidas-optativas'
                                element={<RenderRoute render={(props) => (
                                    <SalidasOptativas {...props} />
                                )} />}
                            />
                            <Route
                                path='becas'
                                element={<RenderRoute render={(props) => (
                                    <Becas {...props} />
                                )} />}
                            />
                            <Route
                                path='pagos-educativos'
                                element={<RenderRoute render={(props) => (
                                    <PagosEducativos {...props} />
                                )} />}
                            />
                            <Route
                                path='cocurriculares'
                                element={<RenderRoute render={(props) => (
                                    <Cocurriculares {...props} />
                                )} />}
                            />
                        </Routes>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(withRequest(Academica));
